/**
 * Forces search form submissions to hit /search with only the `q` parameter,
 * discarding any extra hidden inputs (type, options[...]) injected by search
 * bar blocks (app or theme) so the search backend can't broaden matching
 * beyond what the customer typed.
 */
(function () {
  function getSearchUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
  }

  function isSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.method && form.method.toLowerCase() !== 'get') return false;

    const action = form.getAttribute('action') || '';
    const searchUrl = getSearchUrl();

    return action === searchUrl || action.indexOf(searchUrl) === 0;
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!isSearchForm(form)) return;

      const qInput = form.querySelector('input[name="q"]');
      const query = qInput ? qInput.value.trim() : '';

      event.preventDefault();
      event.stopImmediatePropagation();

      const url = new URL(getSearchUrl(), window.location.origin);
      url.search = '';
      url.searchParams.set('q', query);
      window.location.href = url.toString();
    },
    true
  );
})();
